// Objective: Define the service to get the loan leads
import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';
import { PaginationConst } from '../constants/AppConstant';

/**
 * @description Get release based on the request criteria
 * @param {String} productId
 * @returns {Promise}
 */
export async function createBorrowers(releaseObj: Object = {}) {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/borrowers`,
    data: releaseObj,
  }); return response.data;
}

export async function getBorrowers( pageNumber: number = 0,pageSize:number = PaginationConst.PAGE_SIZE,  filterObj: Object = {}) {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/borrowers?includeOutstanding=true&page=${pageNumber}&size=${pageSize}`,
  }); 
  return response.data;
}

export async function getBorrowerById(borrowerId: string) {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/borrowers/${borrowerId}`,
  }); 
  return response.data;
}

export async function updateBorrower(borrowerId: string, updateData: Object = {}) {
  const response = await HttpClient.PUT({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/borrowers/${borrowerId}`,
    data: updateData,
  }); 
  return response.data;
}

export async function getBlacklistedBorrowers(pageNumber: number = 0, pageSize: number = PaginationConst.PAGE_SIZE) {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/borrowers/blacklisted`,
    params: { page: pageNumber, size: pageSize },
  });
  return response.data;
}

/** Blocklist / eligibility check (email and/or mobile). Extend server-side later for more rules. */
export async function checkBorrowerEligibility(payload: { email?: string; mobile?: string }) {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/borrowers/eligibility-check`,
    data: {
      email: payload.email?.trim() || undefined,
      mobile: payload.mobile?.trim() || undefined,
    },
  });
  return response.data;
}

export async function removeBorrowerBlacklist(borrowerId: string) {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/borrowers/${borrowerId}/remove-blacklist`,
    data: {},
  });
  return response.data;
}

export async function sendBalanceNotification(borrowerId: string, notificationData: {
  useSystemContact: boolean;
  email?: string;
  contactNumber?: string;
  sendEmail: boolean;
  sendSMS: boolean;
}) {
  console.log('sendBalanceNotification API call:', {
    borrowerId,
    notificationData,
    endpoint: `${LEAD_API_PREFIX}/borrowers/${borrowerId}/notify-balance`,
  });
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/borrowers/${borrowerId}/notify-balance`,
    data: notificationData,
  });
  console.log('sendBalanceNotification API response:', response);
  return response.data;
}
